export const DEFAULT_WISHLIST_TITLE = 'My Dating Waitlist';

export const DEFAULT_WISHLIST_DESCRIPTION =
  'Fill this form if you want us to get to know each other better. Honest answers only.';

export const DEFAULT_WISHLIST_FIELDS = [
  { key: 'name', label: 'Full Name', type: 'text', required: true },
  { key: 'age', label: 'Age', type: 'number', required: true },
  { key: 'height', label: 'Height (cm)', type: 'number', required: false },
  { key: 'weight', label: 'Weight (kg)', type: 'number', required: false },
  {
    key: 'relationshipGoal',
    label: 'Relationship Goal',
    type: 'select',
    required: true,
    options: ['Serious relationship', 'Marriage', 'Still exploring'],
  },
  {
    key: 'communicationStyle',
    label: 'Preferred Communication Style',
    type: 'radio',
    required: true,
    options: ['Daily chat', 'Few times a week', 'Flexible'],
  },
  {
    key: 'hobbies',
    label: 'Hobbies (choose all that apply)',
    type: 'multi',
    required: false,
    options: ['Travel', 'Reading', 'Sports', 'Gaming', 'Cooking', 'Music'],
  },
  {
    key: 'coreValues',
    label: 'Top Values',
    type: 'multi',
    required: true,
    options: ['Honesty', 'Loyalty', 'Ambition', 'Kindness', 'Family-focused'],
  },
  {
    key: 'profession',
    label: 'Profession',
    type: 'text',
    required: false,
  },
  {
    key: 'about',
    label: 'Tell us about yourself',
    type: 'textarea',
    required: true,
  },
];
